<script lang="ts">
  import { user } from '../lib/stores/auth';
  import Button from './ui/Button.svelte';
  import UserMenu from './UserMenu.svelte';
  import BrandMark from './BrandMark.svelte';

  // Top nav for the PageShell (auth/account/static routes). The game
  // routes use AppLayout's sidebar instead and never see this. BrandMark
  // is the same component the sidebar uses so the brand reads identically
  // across both shells; right-side actions depend on auth state.
</script>

<header class="top-nav">
  <div class="top-nav__inner">
    <BrandMark />

    <nav class="top-nav__actions" aria-label="Account">
      {#if $user}
        <UserMenu user={$user} />
      {:else}
        <Button variant="ghost" size="sm" href="/login">Sign in</Button>
        <Button variant="primary" size="sm" href="/register">Sign up</Button>
      {/if}
    </nav>
  </div>
</header>
